<div class="map-menu-item">
  <div class="header header--default">
    <h3 class="p-0 border-0">Trends</h3>
  </div>
  <div class="scroll-container scroll-container--trends">
    <rlst-expandable-item
      title="Type"
      [expanded]="false"
      (click)="$event.stopPropagation()"
      [index]="index">
      <div class="expanded-container position-relative">
        <div role="radiogroup"
             class="custom-control-stacked"
             *ngIf="selectedTrendLayer$ | async as trendLayer">
          <label *ngFor="let layer of trendLayers$ | async;  trackBy: trackByFn"
                 class="custom-control custom-radio d-flex align-items-center">
            <input [value]="layer.layerId"
                   [checked]="layer.layerId === trendLayer.layerId"
                   (change)="setTrendsLayer(layer)"
                   tabindex="0"
                   type="radio"
                   name="trend-layer"
                   class="custom-control-input radio-primary">
            <span class="custom-control-indicator"></span>
            <span class="custom-control-description">{{layer.label}}</span>
            <p class="text-danger m-0 p-0 zoom-icon" *ngIf="layer.needZoomIn" rlstTooltip="Zoom In" [tooltipPosition]="'above'">
              <i class="far fa-search-plus" aria-hidden="true"></i>
              <span class="sr-only">Zoom In</span>
            </p>
            <p class="text-danger m-0 p-0 zoom-icon" *ngIf="layer.needZoomOut" rlstTooltip="Zoom Out" [tooltipPosition]="'above'">
              <i class="far fa-search-minus" aria-hidden="true"></i>
              <span class="sr-only">Zoom Out</span>
            </p>
          </label>
        </div>
      </div>
    </rlst-expandable-item>
    <rlst-expandable-item
      title="Aggregation Level"
      [expanded]="false"
      (click)="$event.stopPropagation()"
      [index]="index">
      <div class="expanded-container position-relative">
        <div role="radiogroup" class="custom-control-stacked"
             *ngIf="selectedAggregationLevel$ | async as selectedAggregationLevel">
          <label *ngFor="let aggregationLevel of trendsAggregationLevels" class="custom-control custom-radio d-flex align-items-center">
            <input [value]="aggregationLevel.value"
                   [checked]="aggregationLevel.value === selectedAggregationLevel"
                   (change)="setAggregationLevel(aggregationLevel.value)"
                   type="radio"
                   name="aggregation-level" class="custom-control-input radio-primary">
            <span class="custom-control-indicator"></span>
            <span class="custom-control-description">{{aggregationLevel.label}}</span>
          </label>
        </div>
      </div>
    </rlst-expandable-item>
    <rlst-expandable-item
      title="Property Type"
      [expanded]="false"
      (click)="$event.stopPropagation()"
      [index]="index">
      <div class="expanded-container position-relative">
        <div role="radiogroup" class="custom-control-stacked"
          *ngIf="selectedPropertyType$ | async as selectedPropertyType">
          <label *ngFor="let propertyType of trendsPropertyTypes" class="custom-control custom-radio d-flex align-items-center">
            <input [value]="propertyType.value"
                   [checked]="propertyType.value === selectedPropertyType"
                   (change)="setPropertyType(propertyType.value)"
                   type="radio"
                   name="property-type"
                   class="custom-control-input radio-primary">
            <span class="custom-control-indicator"></span>
            <span class="custom-control-description">{{propertyType.label}}</span>
          </label>
        </div>
      </div>
    </rlst-expandable-item>
  </div>
  <div class="m-0 info-lane info-lane--default">
    <form [formGroup]="opacityLevelForm" class="slider-container">
      <p class="slider-label mb-0 pb-0">Opacity Scale</p>
      <mat-slider
        formControlName="opacityLevel"
        [value]="selectedOpacity$ | async"
        class="w-100 py-1"
        min="0"
        max="100"
        step="10"
        (click)="$event.stopPropagation()">
      </mat-slider>
    </form>
    <rlst-map-layers-info-footer></rlst-map-layers-info-footer>
  </div>
</div>
